import Modal from 'components/Modal'
import IcashRedemptionReversalTx from 'views/MemberProfile/ManualTx/IcashRedemptionReversalTx'

type Props = {
  title: string | undefined
  open: boolean
  onClose: () => void
}

const ModalIcashRedemptionReversalTx = ({
  title,
  open,
  onClose,
}: Props): JSX.Element => {
  return (
    <Modal open={open} title={title} onClose={onClose} noFooter>
      <IcashRedemptionReversalTx onClose={onClose} />
    </Modal>
  )
}

export default ModalIcashRedemptionReversalTx
